<!-- eslint-disable vue/prop-name-casing -->
<script lang="ts" setup>
import type { BoxPosition } from '~/components/box/Box.vue'
import type { LayoutSettings, Column } from '~~/server/api/pagebuilder'

export interface SingleContainerProps {
    data: {
        one_column: Column[]
    }
    layoutSettings?: LayoutSettings
    components: any
}
const props = defineProps<SingleContainerProps>()
const position = computed<BoxPosition>((): BoxPosition => {
    if (props.layoutSettings?.graphic_element_position === 'right')
        return 'top-right'
    return 'top-left'
})
</script>
<template>
  <ContainerFluid class="mb-10 mb-md-20">
    <Box
      :color="props.layoutSettings?.layout_css"
      :padding="
        props.layoutSettings?.layout_css === 'transparent'
          ? 'p-0 m-0'
          : undefined
      "
      :decor-position="position"
      :decor="props.layoutSettings?.graphic_element_position !== 'back'"
      class="w-100"
    >
      <BoxHeader
        v-if="props.layoutSettings?.title"
        :heading="props.layoutSettings.title"
        :subtitle="props.layoutSettings.subtitle"
        heading-level="h2"
      />
      <component
        :is="props.components[component._component_code]"
        v-for="(component, index) in props.data.one_column"
        :id="useSlug(component._component_anchor)"
        :key="index"
        :data-scroll-id="component._component_anchor ? useSlug(component._component_anchor) : null"
        :class="{
          'scroll-margin-top-21': !props.layoutSettings?.title,
          'scroll-margin-top-27': Boolean(props.layoutSettings?.title),
          'scroll-margin-top-md-10': !props.layoutSettings?.title,
          'scroll-margin-top-md-22': Boolean(props.layoutSettings?.title) && index > 0,
          'scroll-margin-top-md-33': Boolean(props.layoutSettings?.title) && index === 0
        }"
        :data="component.data"
      />
    </Box>
  </ContainerFluid>
</template>
